module.exports = __webpack_public_path__ + "static/thumb-2251d9450b51d49bdce4bf9ce0bc9ce2.jpg";